// extracted by mini-css-extract-plugin
export default {"section3":"Realizacje_section3__OkZMV","tile":"Realizacje_tile__+4Cge","text":"Realizacje_text__wMNUr","overlay":"Realizacje_overlay__sNJQO"};